export default __webpack_public_path__ + "static/media/phoneoff-desktop.1a85e241.png";